<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-navigation-drawer :mini-variant.sync="mini" app v-model="drawer">
            <span v-if="mini">
                <v-list-item>
                     <img src="../../assets/gfi-small.png" style="width: 100%; height: auto "/>
                </v-list-item>
            </span>
            <span v-else>
               <v-list-item>
                   <img v-if="productLogo" :src="getProductLogoImageUrl()" class="logoStyle pt-2 pb-2" alt="logo"/>
                </v-list-item>
            </span>

            <v-divider></v-divider>
            <v-list nav dense>
                <v-list-item-group color="primary">
                    <router-link to="/dashboard">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-chart-areaspline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Dashboard</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>

                    <router-link :to="`/${product.toUpperCase()}`"
                                 v-for="(product, idx) in $store.state.home.user.products" :key="idx">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon v-if="multiCategory" small>{{ $t(`icon.${product.toUpperCase()}`)}}</v-icon>
                                <v-icon v-else small>mdi-account-tie</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-if="multiCategory">{{ product }}</v-list-item-title>
                                <v-list-item-title v-else>Results</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>

                    <!--<router-link to="/learningResources">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon small>mdi-file-download</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Learning Resources</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </router-link>-->
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>
<script>
    import {EventBus} from '../../_helpers'
    import {preLoginService} from "../../services"

    export default {
        name: 'SideBar',
        data() {
            return {
                drawer: true,
                mini: true,
                fav: true,
                menu: false,
                item: '',
                message: false,
                hints: true,
                productLogo: ''
            }
        },
        methods: {
            handleSideBar: function () {
                this.mini = !this.mini
            },
            handleSideBarMobile: function () {
                this.drawer = !this.drawer
            },
            logoData: function () {
                preLoginService.getLogoData().then(response => {
                    this.productLogo = response.dataResponse.productLogo
                }).catch(error => {
                    console.log(error)
                })
            },
            getProductLogoImageUrl: function() {
                return process.env.VUE_APP_BACKEND_URL + '/api/media/logo/' + this.productLogo
            }
        },
        computed: {
            isUserAuthenticated() {
                return this.$store.state.home.authenticated
            },
            multiCategory() {
                return this.$store.state.home.user.products.length > 1
            }
        },
        created() {
            EventBus.$on('Clicked', this.handleSideBar)
            EventBus.$on('Sidebar', this.handleSideBarMobile)
            this.logoData()
        }
    }
</script>
<style>
    .v-application a {
        color: #81c342 !important;
        text-decoration: none;
    }
    .logoStyle {
        max-height: 65px;
    }
    .smallLogo {
        max-height: 20px;
    }
</style>
